import type { StoreState } from '@common/types/store';

export interface AudienceEvaluationContext {
  userId?: string;
  networkIds: string[];
  functionIds: string[];
  languageLocale?: string;
  activeFrom?: string | null;
  activeUntil?: string | null;
}

export function buildAudienceContextFromState(state: StoreState): AudienceEvaluationContext {
  const { loggedUser, network } = state;
  const user = loggedUser?.user;

  const networkIds = Object.keys(loggedUser?.memberships?.networks ?? {});
  if (network?.selected && !networkIds.includes(network.selected)) {
    networkIds.push(network.selected);
  }

  const functionIds = Object.keys(loggedUser?.memberships?.functions ?? {});

  const activeFrom = user?.scopes?.organisation?.active_from
    ?? user?.settings?.active_from
    ?? loggedUser?.memberships?.organisation?.active_from
    ?? null;

  const activeUntil = user?.scopes?.organisation?.active_until
    ?? user?.settings?.active_until
    ?? loggedUser?.memberships?.organisation?.active_until
    ?? null;

  return {
    userId: user?.id,
    networkIds,
    functionIds,
    languageLocale: user?.language?.locale ?? user?.translation_language?.locale,
    activeFrom,
    activeUntil,
  };
}
